export default {
  // Navbar
  'nav.home': 'Главная',
  'nav.about': 'О нас',
  'nav.services': 'Услуги',
  'nav.contracts': 'Контракты',
  'nav.profit': 'Доходность',
  'nav.video': 'Видео',
  'nav.invest': 'ИНВЕСТИРОВАТЬ',

  // Hero
  'hero.badge': 'Elon Musk · SpaceX · IPO 2025',
  'hero.title1': 'ИНВЕСТИРУЙ В',
  'hero.title2': 'БУДУЩЕЕ',
  'hero.desc': 'Эксклюзивные инвестиционные контракты в рамках IPO SpaceX от Илона Маска. Доходность от <strong>20% до 50%</strong> за <strong>2 рабочих дня</strong>. Контракты от <strong>3 000 €</strong>.',
  'hero.cta.primary': 'ВЫБРАТЬ КОНТРАКТ',
  'hero.cta.secondary': 'Подробнее',
  'hero.stat1': 'Макс. доходность',
  'hero.stat2': 'Топ контракт',
  'hero.stat3': 'Год IPO',

  // About
  'about.tag': 'О SpaceX IPO',
  'about.title1': 'КОМПАНИЯ',
  'about.title2': 'БУДУЩЕГО',
  'about.p1': 'SpaceX — аэрокосмическая компания Илона Маска, изменившая индустрию космических полётов. Первая частная компания, доставившая астронавтов на МКС, создатель Starlink и разработчик межпланетного корабля Starship.',
  'about.p2': 'IPO SpaceX — историческое событие, открывающее возможность стать акционером компании стоимостью более <strong>$200 миллиардов</strong>. Наши пакеты позволяют войти с минимальным порогом и получить прибыль за <strong>2 рабочих дня</strong>.',
  'about.fact1': 'Оценка SpaceX',
  'about.fact2': 'Успешных запусков',
  'about.fact3': 'Starlink спутников',
  'about.fact4': 'Инвесторов по миру',
  'about.badge': 'Оценка компании',

  // Services
  'services.tag': 'Что мы предлагаем',
  'services.title1': 'НАШИ',
  'services.title2': 'УСЛУГИ',
  'services.sub': 'Полный спектр услуг для комфортного и безопасного инвестирования в IPO SpaceX',
  'services.s1.title': 'Управление портфелем',
  'services.s1.desc': 'Профессиональное управление вашим инвестиционным портфелем. Постоянный мониторинг и оптимизация позиций.',
  'services.s2.title': 'Юридическая защита',
  'services.s2.desc': 'Все контракты юридически оформлены и защищены. Прозрачные условия, без скрытых комиссий.',
  'services.s3.title': 'Аналитика и прогнозы',
  'services.s3.desc': 'Еженедельные отчёты о состоянии портфеля. Аналитика рынка и рекомендации экспертов.',
  'services.s4.title': 'Персональный менеджер',
  'services.s4.desc': 'Персональный менеджер на протяжении всего срока. Доступен 24/7 для консультаций.',
  'services.s5.title': 'Страхование средств',
  'services.s5.desc': 'Ваши инвестиции застрахованы. Гарантированная защита капитала.',
  'services.s6.title': 'Быстрый вывод',
  'services.s6.desc': 'Получение прибыли за 1 рабочий день. Вывод на счёт или крипто-кошелёк.',

  // Contracts
  'contracts.tag': 'Инвестиционные пакеты',
  'contracts.title1': 'ВЫБЕРИ',
  'contracts.title2': 'КОНТРАКТ',
  'contracts.sub': 'Три уровня участия в IPO SpaceX. Выберите пакет под свои цели',
  'contracts.duration': '2 рабочих дня',
  'contracts.profitlabel': 'Доходность',
  'contracts.pure': 'чистой прибыли',
  'contracts.btn': 'ВЫБРАТЬ ПАКЕТ',
  'contracts.disclaimer': '* Доходность указана за 2 рабочих дня. Все контракты юридически оформлены. Инвестиции застрахованы.',
  'contracts.popular': 'Популярный',
  'contracts.starter.f1': 'Минимальный входной порог',
  'contracts.starter.f2': 'Гарантированная доходность 20%',
  'contracts.starter.f3': 'Мгновенные выплаты',
  'contracts.starter.f4': 'Персональный менеджер',
  'contracts.starter.f5': 'Юридическое оформление',
  'contracts.starter.f6': 'Еженедельные отчёты',
  'contracts.advanced.f1': 'Оптимальное соотношение риск/доход',
  'contracts.advanced.f2': 'Гарантированная доходность 30%',
  'contracts.advanced.f3': 'Мгновенные выплаты',
  'contracts.advanced.f4': 'VIP персональный менеджер',
  'contracts.advanced.f5': 'Расширенное юр. сопровождение',
  'contracts.advanced.f6': 'Аналитика рынка в реальном времени',
  'contracts.advanced.f7': 'Страхование инвестиций',
  'contracts.premium.f1': 'Максимальная доходность',
  'contracts.premium.f2': 'Гарантированная доходность 50%',
  'contracts.premium.f3': 'Мгновенные выплаты',
  'contracts.premium.f4': 'Dedicated менеджер 24/7',
  'contracts.premium.f5': 'Полное юр. и налоговое сопровождение',
  'contracts.premium.f6': 'Приоритетный доступ к новым пакетам',
  'contracts.premium.f7': 'Страхование + гарантия возврата',
  'contracts.premium.f8': 'Эксклюзивные IPO-инсайты',

  // Profit
  'profit.tag': 'Финансовые результаты',
  'profit.title1': 'ВАША',
  'profit.title2': 'ДОХОДНОСТЬ',
  'profit.sub': 'Посмотрите, как растут ваши инвестиции за 2 рабочих дня',
  'profit.calc.title': 'КАЛЬКУЛЯТОР ПРИБЫЛИ',
  'profit.calc.invested': 'Вложено',
  'profit.calc.profit': 'Прибыль',
  'profit.calc.total': 'Итого',
  'profit.chart.title': 'ДИНАМИКА РОСТА',
  'profit.chart.sub': 'Прогноз по всем пакетам, 2 рабочих дня',
  'profit.max.title': 'МАКСИМАЛЬНАЯ ПРИБЫЛЬ',
  'profit.max.sub': 'при пакете Premium 10 000 €',

  // Footer
  'footer.nav': 'НАВИГАЦИЯ',
  'footer.legal': 'ПРАВОВАЯ ИНФОРМАЦИЯ',
  'footer.desc': 'Эксклюзивная возможность инвестировать в IPO SpaceX. Присоединяйтесь к космической революции с гарантированной доходностью 20–50% за 2 рабочих дня.',
  'footer.terms': 'Условия использования',
  'footer.privacy': 'Политика конфиденциальности',
  'footer.tax': 'Налоговая информация',
  'footer.copy': '© 2025 SpaceX IPO. Все права защищены.',
  'footer.disclaimer': 'Инвестиции несут риск. Прошлая доходность не гарантирует будущих результатов.',

  // Live toast
  'toast.earned': 'заработал',
  'toast.in': 'за',
  'toast.days': '2 рабочих дня',

  // Video section
  'video.tag': 'Космические новости',
  'video.title1': 'ЛУННАЯ МИССИЯ',
  'video.title2': 'NASA',
  'video.sub': 'NASA запускает первую пилотируемую лунную миссию за полвека — новая эра космических исследований',
  'video.source': 'Euronews Болгария',
  'video.headline1': 'NASA отправило астронавтов к Луне с миссией «Артемида 2»',
  'video.date1': 'Euronews Болгария · Апрель 2026',
  'video.headline2': '«Артемис 2» полетит к Луне на 10-дневную орбиту',
  'video.date2': 'Euronews Болгария · Апрель 2026',
  'video.headline3': 'NASA запускает первую пилотируемую лунную миссию за полвека — репортаж Darik News',
  'video.date3': 'Darik News · Апрель 2026',
  'video.readmore': 'Читать статью на Darik News',
  'video.card1': 'SpaceX Starship — ракета, обеспечивающая новую лунную миссию',
  'video.card2': 'Первая пилотируемая посадка на Луну со времён Apollo 17 (1972)',
  'video.card3': 'Историческое IPO SpaceX напрямую связано с успехом лунной программы',
};